import { searchAPI } from "services/apis.service";

export class DistributionListService {
  #axios;

  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  generateSlug(name) {
    return name
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  async getDistributionLists() {
    try {
      const response = await this.#axios.post(searchAPI.getDistributionLists, {}, { cache: false });      
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async getDistributionListDetails(distributionListId) {
    try {
      const response = await this.#axios.post(searchAPI.getDistributionListDetails, { distributionListId }, { cache: false });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async createDistributionList(distributionName) {
    try {
      const response = await this.#axios.post(searchAPI.createDistributionList, { distributionName }, { cache: false });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateDistributionListUsers(distributionListId, users) {
    try {
      const response = await this.#axios.put(searchAPI.updateDistributionListUsers, { distributionListId, userEmails: users }, { cache: false });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async deleteDistributionList(distributionListId) {
    try {
      const response = await this.#axios.delete(
        searchAPI.deleteDistributionList,
        { data: { distributionListId: distributionListId }, cache: false }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async deleteDistributionListUsers(distributionListId, userEmails) {
    try {
      const response = await this.#axios.delete(
        searchAPI.deleteDistributionListUsers,
        { data: { distributionListId, userEmails }, cache: false }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
